// extracted by mini-css-extract-plugin
module.exports = {"tableReadOnly":"styles_tableReadOnly__2Fhff","tooltipCell":"styles_tooltipCell__8O9QE","tooltip":"styles_tooltip__1KGjf","container":"styles_container__21Foe"};